import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { defaultLocale } from '../config/i18n.config';
import { LocaleProvider } from '../context/localeContext';
import Layout from '../components/Layout';
import GenericPage from './GenericPage';

const GenericPageTemplate = ({ data, pageContext }) => {
  const { frontmatter: page } = data.markdownRemark;

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <GenericPage
          title={page[defaultLocale].title}
          heroImage={page[defaultLocale].image}
          heroContent={page[defaultLocale].hero}
          pageContent={page[defaultLocale].body}
        />
      </Layout>
    </LocaleProvider>
  );
};

GenericPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default GenericPageTemplate;

export const genericPageQuery = graphql`
  query GenericPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        en {
          title
          hero
          body
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
        de {
          title
          hero
          body
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
